import type { VariantProps } from "class-variance-authority"
import type { FC, LinkHTMLAttributes, SVGProps } from "react"
import { Link } from "@tanstack/react-router"
import { cva } from "class-variance-authority"

import type { IconType } from "@productlane/ui"
import { cn } from "@productlane/lib/src/cn"
import { sharedVariantStyles } from "@productlane/ui/src/components/button"

import type { LinkComponentProps } from "@tanstack/react-router"

const styles = cva(
	"relative flex h-fit flex-none select-none items-center gap-2 rounded-full font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-600 disabled:pointer-events-none   max-w-xs",
	{
		variants: {
			variant: sharedVariantStyles,
			size: {
				default: "h-7 min-h-[1.5rem] px-2.5 text-xs",
			},
			disabled: {
				true: "opacity-100",
				false: "",
			},
		},
		defaultVariants: {
			variant: "outline",
			size: "default",
		},
	},
)

interface LinkButtonProps
	extends LinkHTMLAttributes<HTMLAnchorElement>, VariantProps<typeof styles> {
	icon?: LucideIcon | IconType
	iconClassName?: string
	disabled?: boolean
}

export const LinkButton: FC<LinkComponentProps & LinkButtonProps> = ({
	children,
	icon: Icon,
	iconClassName,
	variant = "outline",
	disabled,
	...props
}) => {
	return (
		<Link {...props} className={cn(styles({ variant, disabled }))}>
			{!!Icon && (
				<Icon
					className={cn("h-4 w-4 text-secondary", iconClassName)}
					strokeWidth={1.75}
				/>
			)}
			{children}
		</Link>
	)
}

type LucideIcon = FC<SVGProps<SVGSVGElement>>
